<template>
  <ul class="tree-view" v-if="condition">
    <TreeItem class="item" :item="condition"></TreeItem>
  </ul>
</template>

<script>
import TreeItem from '@/components/treeView/TreeItem'

export default {
  name: 'TreeView',
  components: { TreeItem },
  props: {
    condition: Object,
  },
  data() {
    return {
      // treeData: {
      //   label: 'CONDITION',
      //   children: [
      //     { label: 'Audit Finding:Finding Status EQUAL TO Rectified' },
      //     { label: 'AND' },
      //     { label: 'Audit Finding:Finding Status EQUAL TO Withdrawn' },
      //     {
      //       label: 'AND',
      //       children: [
      //         { label: 'Audit Finding:Finding Status EQUAL TO Unknown' },
      //         { label: 'OR' },
      //         { label: 'Audit Finding:Finding Status EQUAL TO Open' },
      //       ],
      //     },
      //   ],
      // },
    }
  },
}
</script>

<style scoped>
.tree-view {
  font-size: 14px;
  line-height: 21px;
  @apply p-4;
}
</style>
